import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { amplitudeModule } from '@/modules/amplitude';
import { canLogEvents } from '@/utils/canLogEvents';

import { ProgressScreen } from './ProgressScreen';

export const ScreenProgress: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Progress 40',
      });
    }
  }, []);

  return (
    <ProgressScreen
      progress={40}
      backgroundImage={`${S3_BUCKET_URL}/own-ai-compatibility/progress/progress-40.png`}
      topTitle="Oh, you're already showing your spicy side…"
      mainTitle="But we're not done yet."
      subtitle="Just a few more and we'll unlock your perfect&nbsp;match 😈"
      buttonText="Continue"
    />
  );
};
